<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from '@/store/modules/use-common.store'

// 根组件
const route = useRoute()
const commonStore = useCommonStore()
const routerInclude = computed(() => commonStore.routerInclude)
</script>

<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="routerInclude">
      <component :is="Component" :key="route.path" />
    </keep-alive>
    <!-- <component :is="Component" :key="route.path" v-if="!route.meta.keepAlive" /> -->
  </router-view>
</template>

<style scoped>
/* 全局样式在styles/index.scss中定义 */
</style>
